import { Suspense, type ReactNode } from "react";
import { useLocation } from "react-router";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import Header from "./Header";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  // Generate opened on crm.ithnk.com uses the whole width for its table; inside the ThnkOS tab (a frame) it keeps the set width
  const wide =
    useLocation().pathname.startsWith("/generate") &&
    window.self === window.top;
  return (
    <DataImportProvider>
      <Header />
      <main
        className={wide ? "mx-auto p-4" : "max-w-screen-xl mx-auto p-4"}
        id="main-content"
      >
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </main>
      <Notification />
    </DataImportProvider>
  );
};
